import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'
import { Divider } from 'antd'

export const PaddedDiv = styled(Flex)`
  padding: 10px 25px;
  gap: 25px;
`
export const SectionWrapper = styled(Flex)`
  width: 100%;
  overflow: scroll;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: none;
  }

  // box-shadow: 0px 4px 12px rgba(153, 153, 153, 0.35);
  // border: 1px solid ${COLORS.PAGE_BORDER};
`
export const TopHeader = styled(Flex)`
  position: relative;
  width: 100%;
  font-size: ${FONT.F_3XL};
`
export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: ${FONT.F_XL};
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`
export const CardRow = styled(Flex)`
  gap: 25px;
`
export const EmptyWrapper = styled(Flex)`
  margin: 50px 0px;
  margin: ${props => props?.isSpin && '102px 0px'};
`
export const VerticalDivider = styled(Divider)`
  height: 30px;
  color: #cccfd6;

  .ant-divider-vertical {
    position: relative;
    top: -0.06em;
    display: inline-block;
    height: 0.9em;
    margin: 0 8px;
    vertical-align: middle;
    border-top: 0;
    border-left: 5px solid #cccfd6;
  }
`
export const Span = styled.span`
  color: #000;
`

export const Count = styled.div`
  padding-top: 8px;
  font-size: 14px;
  color: ${COLORS.GREY_T_35};
`
export const DropDownContent = styled.div`
  font-family: 'Plus Jakarta Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */
  // margin-top: 10px;

  color: #0a0f2b;
`
export const Capitalize = styled.div`
  text-transform: capitalize;
`
export const ImageAlign = styled.div`
  display: 'flex !important';,
  gap: '10px',

`
